import AbstractRestDownloadTask from '@vertical-plus/vue-js-api-platform/dist/model/task/abstract-rest-download-task';
import TaskParamsInterface from '@vertical-plus/vue-js-api-platform/dist/model/task/task-params-interface';

export default class DownloadTdsInvoiceTask extends AbstractRestDownloadTask
{
    public month!: string;

    public async run(): Promise<void>
    {
        await this.execute();
    }

    protected get url(): string
    {
        return '/report/tds-invoice';
    }

    protected get params(): TaskParamsInterface|null
    {
        return {
            month: this.month,
        };
    }

    protected get filename(): string
    {
        return `Invoice-Breakdown-${ this.month }.xlsx`;
    }
}